export default class WorkPlanViewCtrl {

  constructor ($scope, $stateParams, WorkPlanParametrizationSrv) {
    this.WorkPlanParametrizationSrv = WorkPlanParametrizationSrv
    this.$stateParams = $stateParams
    this.workplan = {}
    this.stages = []
    this.periods = []
    this.currentPage = 0
    this.subPeriods = {}
    this.subPeriods.showOnlyDateInputs = false
    this.minDateEndDate = new Date()

    this.activate()
  }//FIN DEL CONSTRUCTOR

  activate () {
    return this.getWorkPlan().then(this.getStage().then(this.getPeriodicity()))
  }

  getWorkPlan () {
    let header = {id: this.$stateParams.id}
    return this.WorkPlanParametrizationSrv.getWorkPlan.get(header).$promise.then((dataReturn) => {
      if (dataReturn.status === true) {
        this.workplan = dataReturn.data
        this.workplan.id_code = this.$stateParams.id
        this.workplan.start_date = moment(this.workplan.start_date,'YYYY-MM-DD').toDate()
        this.workplan.end_date = moment(this.workplan.end_date,'YYYY-MM-DD').toDate()
        
        this.periodSelected(this.workplan.period)
        for (var period in this.workplan.subperiod.dates) {
          this.workplan.subperiod.dates[period].start_date = moment(this.workplan.subperiod.dates[period].start_date,'YYYY-MM-DD').toDate()
          this.workplan.subperiod.dates[period].end_date = moment(this.workplan.subperiod.dates[period].end_date,'YYYY-MM-DD').toDate() 
        }
        for (var stage in this.workplan.stages) {
          this.workplan.stages[stage].start_date = moment(this.workplan.stages[stage].start_date,'YYYY-MM-DD').toDate()
          this.workplan.stages[stage].end_date = moment(this.workplan.stages[stage].end_date,'YYYY-MM-DD').toDate()
        }
      }
    })
  }

  getStage () {
    return this.WorkPlanParametrizationSrv.getStage.get().$promise.then((dataReturn) => {
      if (dataReturn.status === true) {
        this.stages = dataReturn.data
      }
    })
  }

  getPeriodicity () {
    this.WorkPlanParametrizationSrv.getPeriodicity.get().$promise.then((dataReturn) => {
      if (dataReturn.status === true) {
        this.periods = dataReturn.data
      }
    })
  }

  moveToPage (pageNumber) {
    if (pageNumber && pageNumber >= 0) {
      this.currentPage = pageNumber
    } else {
      this.currentPage = 0
    }
  }

  periodSelected (period) {
    if (period.ds_name === 'Anual' && period !== undefined) {
      this.subPeriods.showOnlyDateInputs = true
    } else {
      this.subPeriods.showOnlyDateInputs = false
    }
  }

  showPage (page) {
    return page === this.currentPage
  }
  
  preventInput(event){
    var  vKey = 86
     if (event.keyCode == vKey)
          event.preventDefault()
          return;     
  }
}

WorkPlanViewCtrl.$inject = ['$scope', '$stateParams', 'WorkPlanParametrizationSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workPlanParametrization/view/workPlanViewCtrl.js